import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';


export const useIsSearchMode = (filterDefaultValues, resource) => {
	const isSearchMode = useSelector((state) => {
		const filters = state.admin.resources[resource] &&
			!isEmpty(state.admin.resources[resource].list.params.filter)
			? state.admin.resources[resource].list.params.filter
			: filterDefaultValues;
		if (!filters) return false;
		return filters["is_search"];
	});
	return isSearchMode;
};
